<template>
    <el-dialog title="创建积分补偿" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true"
        width="35%">
        <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="106px">
            <el-form-item label="用户ID" prop="user_id">
                <el-input v-model="form.user_id"></el-input>
            </el-form-item>
            <el-form-item label="补偿积分数量" prop="num">
                <el-input type="number" v-model="form.num" oninput="if(value>100000000)value=99999999"></el-input>
            </el-form-item>
            <el-form-item label="补偿类型" required>
                <div style="display:flex; align-item:center;">
                    <el-form-item prop="type">
                        <el-select v-model="form.type" placeholder="请选择" @change="handleChange">
                            <el-option label="活动" :value="1" />
                            <el-option label="测评" :value="2" />
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="type_id">
                        <el-select v-loading="selectLoading" v-model="form.type_id" collapse-tags
                            style="margin-left:20px;" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.id" :label="item.title || item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.remarks" />
            </el-form-item>
            <el-row type="flex" justify="end">
                <el-button @click="trunOff" :loading="upLoading">取消</el-button>
                <el-button type="primary" @click="onSubmit" :loading="upLoading">确认</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import { pointCompensation } from "@/api/pointManagement.js"
import { banner } from "@/api/operation.js"
export default {
    data: () => ({
        rules: {
            user_id: [
                { required: true, message: "请输入用户ID", trigger: 'blur' }
            ],
            num: [
                { required: true, message: "请输入积分数量", trigger: 'blur' }
            ],
            type: [
                { required: true, message: "请选择", trigger: 'blur' }
            ],
            type_id: [
                { required: true, message: "请选择", trigger: 'blur' }
            ],
            remarks: [
                { required: true, message: "请输入内容", trigger: 'blur' }
            ]
        },
        form: {
            user_id: '',
            num: '',
            type: null,
            type_id: null,
            remarks: ''
        },
        options: [],
        selectLoading: false,
        upLoading: false
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        onSubmit() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.upLoading = true
                    pointCompensation.create(this.form).then(res => {
                        console.log(res)
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        })
                        this.trunOff()
                        this.$emit('success')
                        this.upLoading = false
                    }).catch(err => { console.log(err); this.upLoading = false })
                }
            })
        },
        handleChange(e) {
            console.log('更换', e)
            this.selectLoading = true
            banner.navigationType(e).then(res => {
                console.log('获取到', res)
                this.options = res.data
                if (this.type == 'add') this.form.type_id = this.options[0].id
                this.selectLoading = false
            }).catch(err => { console.log('失败', err) })
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
    },
}
</script>

<style lang="scss" scoped>

</style>